import { Box } from "@material-ui/core";
import React, { useState, useEffect, useCallback, useRef } from "react";
import BubbleSection from "./BubbleSection";
import ListSection from "./ListSection";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import styles from "assets/jss/material-kit-react/views/landingPageSections/bubbleStyle.js";
import classNames from "classnames";
import { isMobile } from "react-device-detect";
import useWindowSize from "useWindowSize";
import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);
const BubbleControlSection = ({ doc, english, scrollToElement, id }) => {
  const [bubbles, setBubbles] = useState(false);
  const [bubbleInfo, setBubbleInfo] = useState(null);
  const [bubbleName, setBubbleName] = useState(null);
  const [investment, setInvestment] = useState(null);
  const [lastBubbleClicked, setLastBubbleClicked] = useState(null);
  const classes = useStyles();
  const { width } = useWindowSize();

  const findTranslatedBubble = useCallback(() => {
    let bobb = [];
    doc.forEach((item) => {
      if (item.title[0].text === lastBubbleClicked) {
        if (english) {
          bobb = item.english_text;
        } else {
          bobb = item.text;
        }
      }
    });
    return bobb;
  }, [doc, lastBubbleClicked, english]);

  const titleRef = useRef();

  const handleScroll = () => {
    scrollToElement(titleRef.current);
  };

  const handleBubbleClick = useCallback(
    (bubble) => {
      let found = false;
      doc.forEach((item) => {
        if (item.title[0].text === bubble.name) {
          found = true;

          setInvestment(
            english
              ? item.investment_size_usd[0].text
              : item.investment_size[0].text
          );
          setBubbleName(bubble.name);
          setLastBubbleClicked(item.title[0].text);
        }
      });
      if (!found) {
        setInvestment(null);
        setLastBubbleClicked(null);
      }
    },
    [doc, setInvestment, setLastBubbleClicked, english, setBubbleName]
  );

  useEffect(() => {
    if (doc != null && lastBubbleClicked != null) {
      const translatedBubble = findTranslatedBubble();
      setBubbleInfo(translatedBubble);
    }
  }, [doc, lastBubbleClicked, findTranslatedBubble]);

  useEffect(() => {
    if (lastBubbleClicked != null) {
      handleBubbleClick({ name: lastBubbleClicked });
      setBubbleInfo(findTranslatedBubble());
    }
  }, [english, lastBubbleClicked, findTranslatedBubble, handleBubbleClick]);

  const compact = isMobile || width <= 800;

  return (
    <div className={classes.rootContainer} ref={titleRef} id={id}>
      <div className={classes.imgContainer}></div>
      <div className={classNames(classes.section)}>
        <div style={{ marginTop: "3vh" }}>
          <h2 className={classes.bubbleSectionTitle}>
            {english
              ? "Which companies are involved"
              : "Hvilke selskaper er involverte?"}
          </h2>
          {!compact && (
            <Box display="inline">
              <Button
                color={bubbles ? "info" : "clear"}
                size="med"
                round
                onClick={() => setBubbles(true)}
              >
                {english ? "View Bubbles" : "Se Bobler"}
              </Button>
              <Button
                color={bubbles ? "clear" : "info"}
                size="med"
                round
                onClick={() => setBubbles(false)}
              >
                {english ? "View List" : "Se Liste"}
              </Button>
            </Box>
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "start",
            justifyContent: "center",
          }}
        >
          {bubbles && !compact ? (
            <BubbleSection
              name={bubbleName}
              doc={doc}
              english={english}
              info={bubbleInfo}
              investment={
                doc != null && lastBubbleClicked != null && investment
              }
              onClickCallBack={handleBubbleClick}
              title={lastBubbleClicked}
            />
          ) : (
            <ListSection
              english={english}
              doc={doc}
              handleScroll={handleScroll}
            />
          )}
        </div>
      </div>
    </div>
  );
};

BubbleControlSection.propTypes = {
  doc: PropTypes.array,
  english: PropTypes.bool,
  scrollToElement: PropTypes.func,
};

export default BubbleControlSection;
